// extracted by mini-css-extract-plugin
module.exports = {"card":"_6c97079b1b--card--DGbds","name":"_6c97079b1b--name--tMO1c","img":"_6c97079b1b--img--V4GWZ"};